import { render, staticRenderFns } from "./spider-table.vue?vue&type=template&id=71d56231&scoped=true&"
import script from "./spider-table.vue?vue&type=script&lang=js&"
export * from "./spider-table.vue?vue&type=script&lang=js&"
import style0 from "./spider-table.vue?vue&type=style&index=0&id=71d56231&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d56231",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDataTable,VIcon,VPagination,VTooltip})
